import { render, staticRenderFns } from "./LpuHeadline.vue?vue&type=template&id=fb05ae90&scoped=true&"
import script from "./LpuHeadline.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuHeadline.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./LpuHeadline.vue?vue&type=style&index=0&id=fb05ae90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb05ae90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb05ae90')) {
      api.createRecord('fb05ae90', component.options)
    } else {
      api.reload('fb05ae90', component.options)
    }
    module.hot.accept("./LpuHeadline.vue?vue&type=template&id=fb05ae90&scoped=true&", function () {
      api.rerender('fb05ae90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuHeadline.vue"
export default component.exports